import { Button } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useBookingRecoilValue, useNewNavigate } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Flex } from "@chakra-ui/react";

export const RoomPhoto = ({ room }: { room: RoomType }) => {
    const { onNavigate } = useNewNavigate();
    const bookingURL = useBookingRecoilValue();
    const { MEDIAS } = useDesignMaxTheme();
    const { isLaptop, isMobile } = MEDIAS();

    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    return (
        <Flex position="relative" flex="1" gap="80px">
            {!isMobile && <Box w="2px" h="400px" bg="#6b6b6b" mt="104px" />}
            <Flex w="100%" flexDir={isMobile ? "column-reverse" : "column"} gap={isMobile ? "64px" : "80px"}>
                <Box position="relative" w="100%">
                    <Box
                        position="relative"
                        zIndex="3"
                        w="100%"
                        h={isMobile ? "256px" : "608px"}
                        background={
                            room.imgList[0] ? `url(${room.imgList[0].img_URL})no-repeat center/cover` : "gray.100"
                        }
                    />
                    <Box
                        position="absolute"
                        zIndex="0"
                        display={!isLaptop ? "block" : "none"}
                        top="50%"
                        right="-132px"
                        w="212px"
                        h="400px"
                        transform="translateY(-50%)"
                        bg="#3b6c8d"
                    />
                </Box>
                <Flex gap="16px">
                    <Button
                        w={isMobile ? "100%" : "auto !important"}
                        sizeType="large"
                        roundType="none"
                        {...FONT("pretendard", 16, 500, 1.5)}
                        color="#3b6c8d"
                        borderType="navy"
                        onClick={() => onNavigate({ path: "/guide" })}
                    >
                        유의사항
                    </Button>
                    <Button
                        w={isMobile ? "100%" : "auto !important"}
                        sizeType="large"
                        roundType="none"
                        {...FONT("pretendard", 16, 500, 1.5)}
                        backgroundType="navy"
                        borderType="navy"
                        color="#fff"
                        onClick={() => onLink(bookingURL)}
                    >
                        예약하기
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
};
